import React, {Component} from 'react';
import DatePicker from "./DatePicker";
import TimePicker from "./TimePicker";

const forceTwoDigits = (number: number): string => {
    return number.toString().padStart(2, '0');
};

interface DateTimePickerProps {
    id: string;
    name: string;
    value: string | number | Date;
    onChange: (event: { target: { name: string; value: Date; type: string } }) => void;
    inputClassNames?: string;
}

interface DateTimePickerState {
    date: string;
    time: string;
}

/** Loosely-typed shape of the native/synthetic change events emitted by DatePicker and TimePicker. */
interface DateOrTimeChangeEvent {
    target: {
        name: string;
        value: string;
        type?: string;
        checked?: boolean;
    };
}

class DateTimePicker extends Component<DateTimePickerProps, DateTimePickerState> {

    constructor(props: DateTimePickerProps) {
        super(props);

        this.state = this.initState(this.props.value);
    }

    UNSAFE_componentWillReceiveProps(nextProps: DateTimePickerProps) {
        if (nextProps.value !== this.props.value) {
            this.setState(this.initState(nextProps.value))
        }
    }

    initState(value: string | number | Date): DateTimePickerState {
        const dateTime = value ? new Date(value) : null;
        const datePart = dateTime ? `${forceTwoDigits(dateTime.getMonth() + 1)}/${forceTwoDigits(dateTime.getDate())}/${dateTime.getFullYear()}` : '';
        const timePart = dateTime ? `${forceTwoDigits(dateTime.getHours())}:${forceTwoDigits(dateTime.getMinutes())}` : '';

        return {
            date: datePart,
            time: timePart
        }
    }

    onChange = (event: unknown): void => {
        const {name, value, type, checked} = (event as DateOrTimeChangeEvent).target;
        const fieldValue = (type === 'checkbox') ? checked : value;

        this.setState({[name]: fieldValue} as Pick<DateTimePickerState, keyof DateTimePickerState>, () => {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: new Date(this.state.date + ' ' + this.state.time),
                    type: 'text'
                }
            });
        });
    };

    render() {
        return (
            <div>
                <DatePicker inputClassNames={this.props.inputClassNames}
                            id={this.props.id + "-date"}
                            name="date"
                            value={this.state.date}
                            onChange={this.onChange}
                />
                <TimePicker inputClassNames={this.props.inputClassNames}
                            id={this.props.id + "-time"}
                            name="time"
                            value={this.state.time}
                            onChange={this.onChange}/>
            </div>
        )
    }
}

export default DateTimePicker;
